import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-page-not-found-404',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './page-not-found-404.component.html',
  styleUrl: './page-not-found-404.component.scss',
  providers: []
})
export class PageNotFound404Component {

  constructor() {

  }
}
